var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1a1 1 0 011-1h20a1 1 0 011 1v5a4 4 0 01-4 4h-.072A6.999 6.999 0 0113 15.928V18h1a5 5 0 015 5 1 1 0 01-1 1H6a1 1 0 01-1-1 5 5 0 015-5h1v-2.072A7 7 0 015.072 10H5a4 4 0 01-4-4V1zm11 19h-2a3 3 0 00-2.828 2h9.656A2.999 2.999 0 0014 20h-2zM3 2h2v6a2 2 0 01-2-2V2zm16 6V2h2v4a2 2 0 01-2 2zm-2-6v7A5 5 0 117 9V2h10z"
  })));
}
export default SvgTrophyOutline;